import { CurrencyCode } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createOutboundTollingAgreementAtom = createMutationAtomFactory(
  'production.createOutboundTollingAgreement',
  (params: {
    agreementNumber: string;
    processorAccountId: string;
    processingTypeId: string;
    effectiveDate: string;
    expirationDate?: string;
    pricePerUnit?: { amount: number; currencyCode: CurrencyCode };
    priceUnit?: string;
    expectedYieldPercentage?: number;
    terms?: string;
    isActive: boolean;
    facilityId: string;
  }) => ({
    productionOutboundTollingAgreementCreate: {
      __args: {
        input: {
          agreementNumber: params.agreementNumber,
          processorAccountId: params.processorAccountId,
          processingTypeId: params.processingTypeId,
          effectiveDate: params.effectiveDate,
          expirationDate: params.expirationDate,
          pricePerUnit: params.pricePerUnit,
          priceUnit: params.priceUnit,
          expectedYieldPercentage: params.expectedYieldPercentage,
          terms: params.terms,
          isActive: params.isActive,
          facilityId: params.facilityId,
        },
      },
      id: true,
      agreementNumber: true,
    },
  }),
);

export const updateOutboundTollingAgreementAtom = createMutationAtomFactory(
  'production.updateOutboundTollingAgreement',
  (params: {
    id: string;
    agreementNumber?: string;
    expirationDate?: string;
    pricePerUnit?: { amount: number; currencyCode: CurrencyCode };
    priceUnit?: string;
    expectedYieldPercentage?: number;
    terms?: string;
    isActive?: boolean;
  }) => ({
    productionOutboundTollingAgreementUpdate: {
      __args: {
        id: params.id,
        input: {
          agreementNumber: params.agreementNumber,
          expirationDate: params.expirationDate,
          pricePerUnit: params.pricePerUnit,
          priceUnit: params.priceUnit,
          expectedYieldPercentage: params.expectedYieldPercentage,
          terms: params.terms,
          isActive: params.isActive,
        },
      },
      id: true,
      agreementNumber: true,
    },
  }),
);
